import { useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { timestamp } from "@/api/firebase/firebase.config";
import { Job } from "@/models/Job.model";

export const useAddJob = () => {
  const user = useCurrentUserProfile((s) => s.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const addJobListing = async (job: Job) => {
    if (!user) {
      setError(new Error("User not authenticated"));
      return;
    }

    setLoading(true);
    try {
      await collectionRef.Jobs.doc().set({
        ...job,
        created_at: timestamp.now(),
        created_by: user.uid,
        status: "draft",
      });
      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  return { addJobListing, loading, error };
};
